import {
  DeleteSystemTopMenuRequest,
  DeleteSystemTopMenuRequestToJSON,
  HTTPBody,
  RegisterSystemTopMenuRequest,
  RegisterSystemTopMenuRequestToJSON,
  SystemTopMenu,
  SystemTopMenuFromJSON,
  UpdateSystemTopMenuRequest,
  UpdateSystemTopMenuRequestToJSON
} from '@/api'
import * as runtime from '../runtime'

export class SystemTopMenuApi extends runtime.BaseAPI {
  /**
   * トップメニュー一覧取得
   * トップメニュー一覧を取得する
   */
  async getSystemTopMenus(): Promise<SystemTopMenu[]> {
    const response = await this.requestGet(`/system-top-menus`)

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(SystemTopMenuFromJSON)
    ).value()
  }

  /**
   * トップメニューを取得する
   * トップメニュー取得
   */
  async getSystemTopMenu(id: string): Promise<SystemTopMenu> {
    const response = await this.requestGet(`/system-top-menus/${id}`)

    return new runtime.JSONApiResponse(response, jsonValue =>
      SystemTopMenuFromJSON(jsonValue)
    ).value()
  }

  /**
   * トップメニューを登録する
   * トップメニュー登録
   */
  async registerSystemTopMenu(
    request: RegisterSystemTopMenuRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = RegisterSystemTopMenuRequestToJSON(request)

    const response = await this.requestPost('/system-top-menus', bodyParameters)

    return new runtime.VoidApiResponse(response)
  }

  /**
   * トップメニューを更新する
   * トップメニュー更新
   */
  async updateSystemTopMenu(
    request: UpdateSystemTopMenuRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = UpdateSystemTopMenuRequestToJSON(request)

    const response = await this.requestPut(
      `/system-top-menus/${request.id}`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * トップメニューを削除する
   * トップメニュー削除
   */
  async deleteSystemTopMenu(
    request: DeleteSystemTopMenuRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = DeleteSystemTopMenuRequestToJSON(request)

    const response = await this.requestDelete(
      `/system-top-menus/${request.id}`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }
}
